import { Component, Input } from '@angular/core';
import { ColumnConfig } from '../../models/column-config.model';

@Component({
  selector: 'app-display-field',
  standalone: false,
  templateUrl: './display-field.component.html',
  styleUrl: './display-field.component.scss'
})
export class DisplayFieldComponent {
  @Input() column!: ColumnConfig;  
  @Input() value: any;

  constructor() {}

  get displayValue() {
    return this.value ?? '';
  }
}
